import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carroussel-account',
  templateUrl: './carroussel-account.component.html',
  styleUrls: ['./carroussel-account.component.css']
})
export class CarrousselAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/component/account/carroussel-account/carroussel-account.component.ts